import { Link } from "react-router-dom";
import Image from "../../assets/image/index";
import Icons from "../../assets/icon";
import { SmAnimatespin, HoverButton } from "../../components";

import Functions from "./index.function";
export default function Userdetail() {
  const {
    userData,
    handleSubmit,
    onSubmit,
    register,
    errors,
    loading,
    // ActivityData,
  } = Functions();
  return (
    <div className={`xs:py-3 sm:pt-2 xs:px-1 sm:pb-1 sm:h-[calc(100vh-4rem)]`}>
      <div
        className={` bg-[#121212] xs:px-2 sm:px-2 lg:px-2 scroll-container rounded-xl h-full`}
      >
        <div className="pt-6 lg:pt-8">
          <div className="flex justify-center items-center">
            <img
              src={Image?.bestQualityImg}
              className="xs:w-16 sm:w-[70px] lg:w-24"
              alt=""
            />
          </div>
          <div className="flex justify-center items-center xs:mt-5 sm:mt-5 lg:mt-8">
            <Link
              to={
                userData?.role === "fan"
                  ? "/upgrade"
                  : userData?.role === "telent"
                  ? "/packages"
                  : "/packages"
              }
            >
              <HoverButton
                extraClasses={
                  "group xs:w-40 xs:h-8 sm:w-36 sm:h-8 xl:w-40 2xl:w-52 cursor-pointer bg-cover flex lg:h-10 text-secondary font-onestMedium items-center justify-center rounded-full transition-transform transform hover:scale-105 hover:shadow-md"
                }
                BtnTitle={"Upgrade"}
                disabled={false}
                BtnTitleClasses={
                  "text-secondary font-onestMedium xs:text-xs sm:text-sm lg:text-base transition-transform transform group-hover:scale-110 group-hover:text-primary"
                }
              />
            </Link>
          </div>
        </div>
        <div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <h3 className="text-secondary font-onestMedium xs:text-sm sm:text-sm lg:text-base xs:ml-2 sm:ml-3 lg:ml-2 xs:pt-8 sm:pt-10 lg:pt-14">
              Refer Friend
            </h3>
            <div className="relative xs:pt-2 sm:mt-3">
              <input
                type="email"
                name="email"
                placeholder="Email Address"
                // maxLength={30}
                {...register("email", { required: "Email is required" })}
                className={`pl-1.5 sm:pl-2 pr-[50px] sm:pr-16 lg:pr-[72px] xs:py-1.5 outline-none font-onestRegular sm:py-1.5 lg:py-2 w-full
    border ${errors.email ? "border-red-800 shake" : "border-transparent"}
    transition-colors duration-300 ease-in-out
    bg-raisinBlack xs:rounded-md rounded-lg xs:!text-[10px] sm:text-xs lg:text-sm text-graniteGray`}
              />
              <button
                type="submit"
                disabled={loading}
                className="bg-black group absolute right-1 xs:top-[22px] top-1/2 -translate-y-1/2 xs:text-[8px] sm:text-xs lg:text-sm cursor-pointer flex items-center justify-center xs:py-1 xs:px-2 sm:py-1 sm:px-2 text-secondary font-onestMedium xs:rounded-md rounded-lg transition-transform transform hover:scale-105 hover:shadow-md"
              >
                {loading ? <SmAnimatespin /> : "Submit"}
              </button>
            </div>
          </form>
        </div>
        <div>
          <div className="flex justify-between items-center">
            <h3 className="text-secondary font-onestMedium xs:text-sm sm:text-sm lg:text-base xs:ml-2 sm:ml-2 lg:ml-2 xs:pb-3 sm:pb-3 lg:pb-5 xs:pt-4 sm:pt-5 lg:pt-8">
              Activity
            </h3>
            <img
              src={Icons?.activitybtnIcon}
              className="xs:w-4 sm:w-4 lg:w-5"
              alt=""
            />
          </div>
          <div className="space-y-4 h-[250px] flex justify-center items-center scroll-container">
            <h1 className="text-secondary font-unboundedBold text-xl sm:text-2xl lg:text-2xl xl:text-4xl uppercase text-center ">
              coming soon
            </h1>
            {/* {ActivityData.map((activity) => {
                        // Extract the first two words as the key action
                        const [firstWord, secondWord, ...rest] = activity.activityTitle.split(" ");
                        const keyAction = `${firstWord} ${secondWord}`; // Main action
                        const remainingText = rest.join(" "); // Rest of the sentence
                        return (
                            <div key={activity.id} className="flex flex-col lg:pt-1">
                                <span className="text-sm font-medium">
                                    <span style={{ color: activity.activitycolor }}>{keyAction}</span>{" "}
                                    <span className="text-white">{remainingText}</span>
                                </span>
                                <span className="text-xs text-end text-[#929292]">{activity.activitytime}</span>
                            </div>
                        );
                    })} */}
          </div>
        </div>
      </div>
    </div>
  );
}
